import { EnvironmentService } from './services/EnvironmentService';
import { themeService } from './services/theme/ThemeService';
import { isExternalModuleRoute } from './helper/ExternalModuleHelper';
import Login from './views/login/loginPage';

export async function loader(routerState, callback) {
  
  const isExternalModule = isExternalModuleRoute(routerState);
  if (isExternalModule) {
    callback(null);
    return;
  }
  
  await Promise.all([loadBaseLibs(), loadBaseStyles()]);
  if (!themeService.currentTheme) {
    await loadBaseThemes();
  }
  
  callback(null);
}

async function loadBaseStyles() {
  await import(/* webpackChunkName: "base-styles" */ '../libs/index.less');
}

export async function loadBaseLibs() {
  await import(/* webpackChunkName: "base-libs" */ './lib.js');
}

export async function loadBaseThemes() {
  const envService = new EnvironmentService();
  
  if (envService.isKutubee && themeService.includeTheme(themeService.THEMES.THEME_KUTUBEE_DEFAULT)) {
    await import(/* webpackChunkName: "base-kutubee-theme" */ 'kutubee-base/index.less');
  } else if (envService.is2bap && themeService.includeTheme(themeService.THEMES.THEME_TO_BUILD_A_PROFILE_PARTIAL)) {
    await import(/* webpackChunkName: "base-2bap-partial-theme" */ '2bap-partial/index.less');
  } else if (themeService.includeTheme(themeService.THEMES.THEME_DEFAULT)) {
    await import(/* webpackChunkName: "base-theme" */ 'base/index.less');
  }
}

// workaround for preventing flashing of unstyled content on Login page
// TODO: find out why the current theme styles aren't appended into <head></head> before the initial login page render without this loader
export async function loginLoader(routerState) {
  if (!isExternalModuleRoute(routerState)) {
    await loadBaseStyles();
  }
  await loadBaseThemes();
  return Login;
}
